function toLowerCase(value) {
    if ('string' == typeof value) return value.toLowerCase();
    return value;
}
export { toLowerCase };
